export type AuditEventActor = {
    type: "adm_cloud" | "system_user" | "system"
    identifier: string
    display_name: string | null
}

export type AuditEventRow = {
    id: number
    auditable_type: string
    auditable_id: number
    root_type: string | null
    root_id: number | null
    event: "create" | "update" | "destroy" | "duplicate" | string
    object_changes: Record<string, [unknown, unknown]>
    metadata: Record<string, unknown>
    actor_identifier: string
    actor_display_name: string | null
    created_at: string
}

export type AuditEventGroup = {
    request_id: string
    actor: AuditEventActor
    timestamp: string
    events: AuditEventRow[]
}

export const MODULE_KEYS = [
    "employees",
    "general_infos",
    "weekly_reports",
    "payrolls",
    "extrusions",
    "orders",
    "exports",
] as const
export type ModuleKey = typeof MODULE_KEYS[number]
